
// Web Search

import Home from './components/views/WebSearch/Home.vue';


export const routes = [

	{
		path: '/',
		component: Home
	},
	// Redirect to root if route is not foud
	{
		path: '*',
		redirect: '/'
	},
];
